import 'type-for-pixi';
var FontLoader = (function () {
    function FontLoader() {
    }
    FontLoader.loadFonts = function (assetMap, baseUrl) {
        return new Promise(function (resolve) {
            var type = window.type;
            var loader = new type.Loader();
            assetMap.forEach(function (value) {
                loader.add(value.name, "" + baseUrl + value.url);
            });
            loader.once('loadComplete', resolve);
            loader.load();
        });
    };
    return FontLoader;
}());
export { FontLoader };
//# sourceMappingURL=font-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@arcade-client/asset-manager/dist/esm/font-loader.js
// module id = null
// module chunks = 